import {
    INITIATIVE_SET_PATH_REQUEST,
    INITIATIVE_SET_INITIATIVE_CLICKED,
    INITIATIVE_SET_SHOW_PURPOSE
} from '../types';

let regionClicked = JSON.parse(localStorage.getItem('regionClicked'));
regionClicked = regionClicked !== null? regionClicked: {};

let initiativeClicked = JSON.parse(localStorage.getItem('initiativeClicked'));
initiativeClicked = initiativeClicked !== null? initiativeClicked: {};

const initialState = {
    regionClicked,
    initiativeClicked,
    showpurpose:true
}

export default function(state = initialState, action) {
    switch(action.type) {
        case INITIATIVE_SET_PATH_REQUEST:
            let regionClicked = action.payload;
            localStorage.setItem('regionClicked', JSON.stringify(regionClicked));
            return {
                ...state,
                regionClicked
            }
        case INITIATIVE_SET_INITIATIVE_CLICKED:
            let initiativeClicked = action.payload;
            localStorage.setItem('initiativeClicked', JSON.stringify(initiativeClicked));
            return {
                ...state,
                initiativeClicked
            }
        case INITIATIVE_SET_SHOW_PURPOSE:
            return {
                ...state,
                showpurpose:action.payload
            }
        default:
            return state;
    }
}